import { Box, Typography, Grid } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const PrizesCarousel = ({ prizes }) => {
    return (

        <Grid container spacing={1}>
            {prizes.map((prize) => (
                <Grid item xs={12} md={12} key={prize._id}>
                    <PrizeCard prize={prize} />
                </Grid>
            ))}
        </Grid>
    );
};

const PrizeCard = ({ prize }) => {

    let images = prize?.image?.flatMap(imgObj => imgObj.image.map(img => img.url)) || [];

    return (
        <>
            <Box
                sx={{
                    borderRadius: 3, p: 2,
                    // backgroundColor: '#fff',
                    border: "1px solid #dedede", position: "relative",
                }}
            >
                <Carousel showThumbs={false} infiniteLoop>
                    {images.map((url, index) => {
                        console.log("url", url || "https://png.pngtree.com/png-vector/20230311/ourmid/pngtree-trophy-line-icon-vector-png-image_6644522.png")

                        return (
                            <Box key={index} component="img" height="200"
                                sx={{ borderRadius: 2, width: '100%', height: 300, objectFit: "contain" }}
                                src={url !== "" ? url : "https://png.pngtree.com/png-vector/20230311/ourmid/pngtree-trophy-line-icon-vector-png-image_6644522.png"}
                                alt={`Prize image ${index + 1}`}
                            />
                        )
                    })}
                </Carousel>

                <Box mt={2}>
                    <Typography fontWeight="bold">
                        {prize?.title}
                    </Typography>
                    <Typography color="text.secondary">
                        {prize?.description}
                    </Typography>
                 
                </Box>
            </Box>
        </>
    );
};



export default PrizesCarousel;
